var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { AppinfoService } from 'app/services/appinfo.service';
import { CommonFunctionService } from 'app/services/common-function.service';
import { GfoService, ColumnFilter, FilterOperatorName, ColumnOperator } from './../../services/gfo.service';
import { RequestTableService } from 'app/services/request-table.service';
var CommonColumnFilterComponent = /** @class */ (function () {
    function CommonColumnFilterComponent(appinfoService, commonService, gfoService, requestTableService) {
        this.appinfoService = appinfoService;
        this.commonService = commonService;
        this.gfoService = gfoService;
        this.requestTableService = requestTableService;
        this.columns = [];
        // Field used to display
        this.displayField = 'name';
        // Field used to store column name
        this.colNameField = 'prop';
        //
        this.filterInfo = {};
        this.domainFilter = [];
        //
        this.onChange = new EventEmitter();
        this.onPressEnter = new EventEmitter();
        // Selected column
        this.selectedColumn = null;
        this.domainList = [];
        // public selectedInDomain: any[] = []; // Selected values in the domain list
        this.showDomain = false;
        // Columns' available operators
        // public operators: ColumnOperator[];
        this.availableOperators = [];
        // Operators that doesn't need to pass filterValue
        this.noFilterValueOperatorNames = ['is empty', 'is null', 'not empty', 'not null'];
    }
    CommonColumnFilterComponent.prototype.transformFilterInfo = function () {
    };
    CommonColumnFilterComponent.prototype.onSelectColumn = function (skipTriggerChange) {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, info, colType, standardColType_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedColumn) return [3 /*break*/, 6];
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        info = this.appinfoService.columnMap[this.selectedColumn[this.colNameField]];
                        if (info) {
                            colType = info.type;
                            standardColType_1 = this.appinfoService.findGeneralCol(colType);
                            this.availableOperators = Object.keys(this.appinfoService.filterOperators).filter(function (i) {
                                return _this.appinfoService.filterOperators[i].compatibleColTypes.indexOf(standardColType_1) > -1;
                            })
                                .map(function (i) {
                                return {
                                    name: _this.appinfoService.filterOperators[i].name,
                                    symbol: _this.appinfoService.filterOperators[i].label,
                                    sq: _this.appinfoService.filterOperators[i].sq
                                };
                            }).sort(function (a, b) {
                                if (a.sq > b.sq) {
                                    return 1;
                                }
                                else if (a.sq < b.sq) {
                                    return -1;
                                }
                                else {
                                    return 0;
                                }
                            });
                            // this.gfoService.columnOperators.filter((o) => {
                            // 	return this.appinfoService.filterOperators[o.name] && this.appinfoService.filterOperators[o.name].compatibleColTypes.indexOf(standardColType) > -1
                            // });
                        }
                        else {
                            this.availableOperators = [];
                        }
                        if (!this.isAutoCheckDomain) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.populateColumnDomain()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 5];
                    case 5:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [3 /*break*/, 7];
                    case 6:
                        this.availableOperators = [];
                        _a.label = 7;
                    case 7:
                        // Update selectedOperator
                        if (this.selectedOperator) {
                            this.selectedOperator = this.availableOperators.find(function (o) { return o.name === _this.selectedOperator.name; });
                        }
                        // this.selectedInDomain = []; // Clear selected domains
                        this.updateFilter(skipTriggerChange);
                        return [2 /*return*/];
                }
            });
        });
    };
    CommonColumnFilterComponent.prototype.onSelectOperator = function (skipTriggerChange) {
        this.updateFilter(skipTriggerChange);
    };
    CommonColumnFilterComponent.prototype.updateFilter = function (skipTriggerChange) {
        //
        if (this.selectedOperator) {
            if (this.selectedOperator.name === 'is null') {
                this.filterValue = 'null';
            }
            else if (this.noFilterValueOperatorNames.indexOf(this.selectedOperator.name) > -1) {
                this.filterValue = '';
            }
        }
        if (!skipTriggerChange) {
            this.onChange.emit(this.getCurrentFilter());
        }
    };
    CommonColumnFilterComponent.prototype.setDefaultOperator = function () {
        this.selectedOperator = this.availableOperators[0]; // this.operators[0]; // Hard Code.
    };
    CommonColumnFilterComponent.prototype.clearFilterValue = function () {
        this.valueList = null;
        this.filterValue = null;
    };
    CommonColumnFilterComponent.prototype.clearAll = function (skipTriggerChange) {
        this.selectedColumn = null;
        this.selectedOperator = null;
        this.clearFilterValue();
        this.updateFilter(skipTriggerChange);
    };
    CommonColumnFilterComponent.prototype.getCurrentFilter = function () {
        // If the filter is not completely defined, return null
        if (!this.selectedColumn || !this.selectedOperator) {
            return null;
        }
        if (!this.filterValue && this.filterValue !== 0 && this.noFilterValueOperatorNames.indexOf(this.selectedOperator.name) === -1) {
            return null;
        }
        if (this.selectedOperator.name === 'not empty') {
            return this.gfoService.getFilter(this.selectedColumn[this.colNameField], 'ne', '');
        }
        else if (this.selectedOperator.name === 'is empty') {
            return this.gfoService.getFilter(this.selectedColumn[this.colNameField], 'eq', '');
        }
        else {
            return this.gfoService.getFilter(this.selectedColumn[this.colNameField], this.selectedOperator.name, this.filterValue);
        }
    };
    CommonColumnFilterComponent.prototype.onEnter = function () {
        this.onPressEnter.emit();
    };
    CommonColumnFilterComponent.prototype.toggleDomain = function () {
        this.showDomain = !this.showDomain;
    };
    CommonColumnFilterComponent.prototype.onSelectDomain = function () {
        var _this = this;
        var selected = this.domainList.filter(function (d) { return d.selected; });
        if (selected.length >= 5) {
            this.exceedMaxSelectedDom = true;
        }
        else {
            this.exceedMaxSelectedDom = false;
        }
        if (selected.length) { // If there're selected values, use IN as operator
            this.selectedOperator = this.availableOperators.find(function (o) { return o.name === 'in'; });
            this.filterValue.value = selected.map(function (d) { return d[_this.domainDisplayCol]; }); // stringify is for display use
            // Update filterValue.displayed based on filterValue.value
            var displayed = this.filterValue.value[0];
            for (var i = 1; i < this.filterValue.value.length; i++) {
                displayed += ',' + this.filterValue.value[i];
            }
            this.filterValue.displayed = displayed;
        }
        else {
            this.filterValue = this.getEmptyFilterValue();
        }
        this.updateFilter();
    };
    CommonColumnFilterComponent.prototype.populateColumnDomain = function () {
        return __awaiter(this, void 0, void 0, function () {
            var columnMap, info, gfo, rsp, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        columnMap = this.appinfoService.columnMap;
                        info = columnMap[this.selectedColumn[this.colNameField]];
                        if (!(info && info.fkTab && info.name)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        gfo = void 0;
                        if (this.domainFilter && this.domainFilter.length) {
                            gfo = this.gfoService.getGfo(this.gfoService.filterLogics.and, this.domainFilter);
                        }
                        return [4 /*yield*/, this.requestTableService.tableGet(info.fkTab, info.fkCol, gfo, {
                                pageNumber: 0
                            }, true)];
                    case 2:
                        rsp = _a.sent();
                        this.domainList = rsp.data;
                        this.domainDisplayCol = info.name;
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        this.domainList = [];
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.domainList = [];
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CommonColumnFilterComponent.prototype.getEmptyFilterValue = function () {
        return {
            displayed: null,
            value: null
        };
    };
    CommonColumnFilterComponent.prototype.ngOnInit = function () {
        // // Default selectedOperator
        // this.selectedOperator = this.operators[0];
    };
    CommonColumnFilterComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.filter && changes.filter.currentValue) {
            var filter_1 = changes.filter.currentValue;
            var selectedCol = this.columns.find(function (c) { return c[_this.colNameField] === filter_1.col; });
            if (selectedCol !== this.selectedColumn) {
                this.selectedColumn = selectedCol;
                this.onSelectColumn(true);
            }
            var selectedOp = this.availableOperators.find(function (o) { return o.name === filter_1.op; });
            if (selectedOp !== this.selectedOperator) {
                this.selectedOperator = selectedOp;
                this.onSelectOperator(true);
            }
            this.filterValue = filter_1.val;
        }
        // Clear filters outside the component
        // if (changes.columns && !changes.columns.firstChange) {
        // 	this.selectedColumn = null;
        // 	this.onChange.emit(null);
        // 	this.selectedOperator = null; // this.operators[0];
        // 	this.filterValue = null;
        // }
    };
    return CommonColumnFilterComponent;
}());
export { CommonColumnFilterComponent };
